import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import THEME from "../../../theme";
import { fs } from "../utils/styles";

// Zeigt die wichtigsten BWA-Kennzahlen ueber alle bisher hochgeladenen Monate - gleiches
// Recharts-Muster wie GewinnChart.js.
const ANGEZEIGTE_SCHLUESSEL = [
  { schluessel: "umsatzerloese", label: "Umsatz", farbe: THEME.colors.success },
  { schluessel: "gesamtkosten", label: "Kosten", farbe: THEME.colors.danger },
  { schluessel: "betriebsergebnis", label: "Betriebsergebnis", farbe: THEME.colors.primary },
];

export default function BwaTrendChart({ trend }) {
  if (!trend || !trend.monate || trend.monate.length < 2) {
    return (
      <div style={fs.karte}>
        <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Entwicklung über die Zeit</h3>
        <p style={{ color: THEME.colors.textMuted, margin: 0 }}>Sobald mindestens zwei Monate hochgeladen sind, erscheint hier ein Verlaufs-Chart.</p>
      </div>
    );
  }

  const daten = trend.monate.map((label, i) => {
    const zeile = { label };
    for (const { schluessel, label: kennzahlLabel } of ANGEZEIGTE_SCHLUESSEL) {
      const serie = trend.serien[schluessel];
      zeile[kennzahlLabel] = serie ? serie.werte[i] : null;
    }
    return zeile;
  });

  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Entwicklung über die Zeit</h3>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={daten}>
          <CartesianGrid strokeDasharray="3 3" stroke={THEME.colors.border} />
          <XAxis dataKey="label" stroke={THEME.colors.textMuted} fontSize={12} />
          <YAxis stroke={THEME.colors.textMuted} fontSize={12} />
          <Tooltip contentStyle={{ background: THEME.colors.surface, border: `1px solid ${THEME.colors.border}`, color: THEME.colors.text }} />
          <Legend />
          {ANGEZEIGTE_SCHLUESSEL.map(({ label, farbe }) => (
            <Line key={label} type="monotone" dataKey={label} stroke={farbe} strokeWidth={2} dot={false} connectNulls />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
